import React from "react";
//import "./context_components.css";
import "../../context/context_components/context_components.css"
import { useSelector } from "react-redux";


export function DotLoaderImg(props) {
    const { isLoading}=useSelector((state)=>state.imageVCStore);
  const { color } = useSelector(state => state.themeStore);
  //console.log(isLoading)

  return (
    <div>
      { isLoading &&
        <div className="dot-loading">
          <span
            style={{
              backgroundColor: color
            }}
          ></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
          <span
            style={{
              backgroundColor: color
            }}></span>
        </div>}
    </div>
  );
}

export default DotLoaderImg;